import React, { useRef, useEffect } from 'react';
import Message from './Message.js';
import LoadingScreen from './LoadingScreen.js';

const ChatWindow = ({ messages, submitCounter, isFetching }) => {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
    }
  }, [messages]);

  return (
      <div className={`chat-window${submitCounter > 0 ? ' chat-window-entered' : ''}`} ref={messagesEndRef}>
        {messages.map((message, index) => (
            <Message key={index} message={message} />
        ))}
        {isFetching && <LoadingScreen />}
      </div>
  );
};

export default ChatWindow;
